import { render, staticRenderFns } from "./NavCurrencySelect.vue?vue&type=template&id=0d380a82&scoped=true"
import script from "./NavCurrencySelect.vue?vue&type=script&lang=js"
export * from "./NavCurrencySelect.vue?vue&type=script&lang=js"
import style0 from "./NavCurrencySelect.vue?vue&type=style&index=0&id=0d380a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d380a82",
  null
  
)

export default component.exports